export default {
	"Order.NoProductsSelected": "未選擇商品",
	"Order.prompt": "提示",
	"Order.UntieTheBindingForTheTimeBeing": "暫不解綁",
	"Order.UnbindTheAccount": "解綁帳號",
	"Order.SorryFailedToCreateOrder": "抱歉，創建訂單失敗！",
	"Order.RepeatPurchasePrompts": "重複購買提示",
	"Order.ignore": "忽略",
	"Order.ViewOrders": "查看訂單",
	"Order.WeChatCanEnterTheAccessAfterAuthorizationRequestAuthorization": "微信授權後可進入訪問，請求授權中···",
	"Order.GotIt": "知道了",
	"Order.PleaseRedeemItInWeChatOrCallAPP": "請在微信或【叫叫】APP內進行兌換",
	"Order.ToPayForThisOrderPleasePayInTheOrderLogisticsOfTheCallPublicAccount": "支付該訂單請在《叫叫》公眾號的訂單物流中進行支付"
}